import { Box, Modal, ModalBody, ModalContent, Text } from "@chakra-ui/react";
import Keyboard from "@/components/keyboard";
import { useState } from "react";
import TitleHeader from "@/components/TitleHeader";
import { LogsButton } from "@/components/Button";
import { GoIcon } from "@/components/icons";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
import { parseAmount } from "@/utils/formatBalance";
import { usdcInfo } from "@/constants/tokens";

const TipAmountModal = ({
  isOpen,
  onClose,
  onValueChange,
}: {
  isOpen: boolean;
  onClose: () => void;
  onValueChange: (value: string) => void;
}) => {
  const [keyboardValue, setKeyboardValue] = useState("0");
  const { currencyUnit, usdToCurrency, localConvertToUsd } =
    useCurrencyExchange();
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"} autoFocus={false}>
      <ModalContent>
        <ModalBody
          sx={{
            background: "#D5742C",
            padding: "20px",
          }}
        >
          <TitleHeader
            title="Tip Amount"
            color="#fff"
            onBack={onClose}
          ></TitleHeader>
          <Box>
            <Text
              sx={{
                fontSize: "70px",
                fontStyle: "normal",
                fontWeight: 900,
                minHeight: "70px",
                textAlign: "center",
                position: "relative",
                wordBreak: "break-all",
                color: "#fff",
                width: "fit-content",
                margin: "60px auto 0",
              }}
            >
              {keyboardValue}
            </Text>
            <Text
              sx={{
                color: "#FFF",
                textAlign: "center",
                fontFamily: "DIN",
                fontSize: "24px",
                fontWeight: 700,
                marginTop: "10px",
              }}
            >
              {currencyUnit}
            </Text>

            <LogsButton
              variant="outlined"
              sx={{
                background: "transparent",
                color: "#fff",
                border: "1px solid #fff",
                width: "160px",
                height: "70px",
                margin: "20px auto 0",
              }}
              onClick={() => {
                onValueChange(
                  localConvertToUsd(
                    parseAmount(keyboardValue, usdcInfo.decimals)
                  )
                );
              }}
            >
              Confirm
              <GoIcon style={{ width: "16px", marginLeft: "4px" }}></GoIcon>
            </LogsButton>
            <Keyboard
              value={keyboardValue}
              onKeyboardClick={(value: string) => {
                setKeyboardValue(value);
              }}
            ></Keyboard>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TipAmountModal;
